const EXPRESSION_MAP = {
  default: "Idle_01",
  idle_2: "Idle_02",
  idle_3: "Idle_03",
  happy: "Smile",
  sad: "Sad",
  surprised: "Surprised",
  laugh: "Laugh",
  disgust: "Disgust",
  angry: "Displeased",
}

export default EXPRESSION_MAP
